export const convertToUserTime = (utcTime: string, omitTime: boolean = false): string => {
  const date = new Date(utcTime);

  if (isNaN(date.getTime())) {
    return '-';
  }

  if (omitTime) {
    return date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }

  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};
